import { sanitizeRichHtml } from '@sg/utils/sanitizeHtml';

/**
 * Tinymce富文本组件粘贴时，处理粘贴的内容
 * 只清除字体格式和大小，保留其他格式（粗体、斜体、下划线、颜色等）
 * @param str 处理后的文本内容
 */
export const convertTextOnPaste = (str?: string): string => {
  if (!str) return '';

  // Sanitize first: assigning unsanitized HTML to innerHTML can fire onerror
  // even on a detached node.
  const divNode = document.createElement('div');
  divNode.innerHTML = sanitizeRichHtml(str);

  /**
   * 清除元素中p和span的字体相关样式，保留其他格式
   * @param element 要处理的元素
   * @returns 处理后的HTML字符串
   */
  const cleanFontStyles = (element: Element): string => {
    // 克隆元素，避免修改原始DOM
    const cloneElement = element.cloneNode(true) as Element;

    // 递归处理所有子元素
    const processElement = (el: Element) => {
      // 只清除 p 和 span 元素中的字体相关样式
      const tagName = el.tagName.toLowerCase();
      if (tagName === 'p' || tagName === 'span') {
        // 清除内联样式中的字体相关属性
        if (el.hasAttribute('style')) {
          const style = el.getAttribute('style') || '';
          // 移除 font-family, font-size 相关样式
          const cleanedStyle = style
            .split(';')
            .filter((s) => {
              const prop = s.trim().toLowerCase();
              return !prop.startsWith('font-family') && !prop.startsWith('font-size') && !prop.startsWith('font:');
            })
            .join(';')
            .trim();

          if (cleanedStyle) {
            el.setAttribute('style', cleanedStyle);
          } else {
            el.removeAttribute('style');
          }
        }

        // 清除 face 属性（旧式字体设置）
        if (el.hasAttribute('face')) {
          el.removeAttribute('face');
        }

        // 清除 size 属性（旧式字体大小设置）
        if (el.hasAttribute('size')) {
          el.removeAttribute('size');
        }
      }

      // 递归处理子元素
      Array.from(el.children).forEach((child) => processElement(child));
    };

    processElement(cloneElement);
    return cloneElement.innerHTML;
  };

  // 处理并返回清理后的HTML
  return cleanFontStyles(divNode);
};
